import { defineMessages } from 'react-intl';
import petFriendly from '../../images/boat/pet-friendly.jpg';
import electrical from '../../images/boat/marina-electrical.jpg';
import boatLaunch from '../../images/boat/boat-launch.jpg';
import restrooms from '../../images/boat/mooring.jpg';
import fishing from '../../images/boat/fishing.jpg';
import fuel from '../../images/boat/fuel.jpg';

export const AMENITIES_MESSAGES = defineMessages({
    electrical: { defaultMessage: 'Electrical' },
    fuel: { defaultMessage: 'Fuel (either gas or diesel selected)' },
    boatLaunch: { defaultMessage: 'Boat Launch' },
    fishing: { defaultMessage: 'Fishing' },
    petFriendly: { defaultMessage: 'Pet Friendly' },
    restrooms: { defaultMessage: 'Restrooms' },
});

export const AMENITIES = [
    {
        value: 'electrical',
        src: electrical,
        translation: AMENITIES_MESSAGES.electrical,
        query: {
            amenities: ['electrical'],
        },
    },
    {
        value: 'fuel',
        src: fuel,
        translation: AMENITIES_MESSAGES.fuel,
        query: {
            amenities: ['fuel'],
        },
    },
    {
        value: 'boatLaunch',
        src: boatLaunch,
        translation: AMENITIES_MESSAGES.boatLaunch,
        query: {
            amenities: ['boatLaunch'],
        },
    },
    {
        value: 'fishing',
        src: fishing,
        translation: AMENITIES_MESSAGES.fishing,
        query: {
            amenities: ['fishing'],
        },
    },
    {
        value: 'petFriendly',
        src: petFriendly,
        translation: AMENITIES_MESSAGES.petFriendly,
        query: {
            amenities: ['petFriendly'],
        },
    },
    {
        value: 'restrooms',
        src: restrooms,
        translation: AMENITIES_MESSAGES.restrooms,
        query: {
            amenities: ['restrooms'],
        },
    },
];

export const FOOTER_LINKS = {
    blog: 'https://blog.letsmarina.com',
    faq: 'https://support.letsmarina.com/boater-faq/',
    about: 'https://join.letsmarina.com/about/',
    marinaSupport: 'https://support.letsmarina.com/marina-support/',
};

export const UNIT_TYPE_BOAT = 'boat';

export const BOAT_UNIT_TYPE_MESSAGES = defineMessages({
    boat: { defaultMessage: 'Boat' },
});

export const BOAT_UNIT_TYPES = [
    {
        value: UNIT_TYPE_BOAT,
        translation: {
        ...BOAT_UNIT_TYPE_MESSAGES.boat,
        },
    },
];